import { ButtonType, DialogFooterButtonsWidget } from '@tableau/widgets';
import * as React from 'react';

import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss } from '~src/commonInfra/dialogs/ReactModalService';
import { DialogFieldParentStyle } from '~src/commonInfra/dialogs/style/DialogStyles';

import { openGenerateKMSKeyDialog } from '../dialogs/KMSKeyGenerateDialog';


export interface KMSKeyReplaceActiveViewProps {
    closeDialog: CloseAndDismiss;
}

export class KMSKeyReplaceActiveView extends React.PureComponent<KMSKeyReplaceActiveViewProps, {}> {

    constructor(props: KMSKeyReplaceActiveViewProps) {
        super(props);
    }


    public render(): JSX.Element {
        return <>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_replaceActiveKMSKeyDialog_Description_1()}</div>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_replaceActiveKMSKeyDialog_Description_2()}</div>
            <div style={DialogFieldParentStyle}>{Messages.extractEncryption_replaceActiveKMSKeyDialog_Description_3()}</div>
            <div style={{ position: 'relative' }}>
                <DialogFooterButtonsWidget
                    buttons={[
                        {
                            buttonType: ButtonType.Outline,
                            children: Messages.cancel(),
                            onClick: this.props.closeDialog.close,
                            testId: 'cancel-button'
                        },
                        {
                            buttonType: ButtonType.Primary,
                            children: Messages.extractEncryption_replaceActiveKMSKeyDialog_Generate_button(),
                            onClick: () => {
                                openGenerateKMSKeyDialog(true, () => {});
                                this.props.closeDialog.close();
                            },
                            testId: 'generate-button'
                        }
                    ]}
                />
            </div>
        </>;
    }
}